<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>
<div>
	<his-search-form [configFile]="moduleOptions.SEARCH_CONFIGURATION_FILENAME">
		<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_CREATE)" customSearchButtons>
			<a routerLink="/researchInfrastructure/create" hisImage="context_add">{{'fs.res.researchInfrastructure.ResearchInfrastructure.search.create' | hisUi}}</a>
		</ng-container>
	</his-search-form>
</div>
